import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

import {Skeleton} from '../../../components/Skeleton';

export const BREAKPOINT_TWO_COL_PX = 1360;
const BREAKPOINT_ONE_COL_PX = 900;
const BREAKPOINT_MOBILE_ONE_COL_PX = 666;

export const Grid = styled.div<{numColumns: number}>`
  align-items: center;
  display: grid;
  white-space: nowrap;
  margin-bottom: 10px;
  grid-template-columns: repeat(${props => props.numColumns}, minmax(0, 1fr));
  grid-gap: 10px;
  margin-bottom: 40px;

  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: ${globals.TABLET_BREAKPOINT}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
  }
  @media (max-width: ${BREAKPOINT_MOBILE_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }
`;
Grid.displayName = 'S.Grid';

export const CardDescription = styled.div`
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: ${THEME.textTertiary};
  font-family: 'Source Sans 3';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  align-items: center;
`;
CardDescription.displayName = 'S.CardDescription';

export const skeletonCardContent = css`
  white-space: nowrap;
  overflow: hidden;
  background: ${THEME.bgSurface};
  color: ${THEME.textPrimary};
  border: 1px solid ${THEME.border};
  border-radius: 8px;
  padding: calc(${globals.spu} * 1.375);
  transition: border-color 0.3s;
`;

export const cardContent = css`
  overflow: hidden;
  white-space: nowrap;
  background: ${THEME.bgSurface};
  color: ${THEME.textPrimary};
  &:hover {
    color: ${THEME.textPrimary};
  }
  border: 1px solid ${THEME.border};
  &:hover {
    border-color: ${THEME.accent};
  }
  border-radius: 8px;
  padding: calc(${globals.spu} * 1.375);
  transition: border-color 0.3s;
`;

export const SkeletonText = styled(Skeleton)<{width?: number}>`
  display: flex;
  width: ${props => (props.width ? props.width + 'px' : '100%')};
  max-width: 100%;
`;
SkeletonText.displayName = 'S.SkeletonText';

export const SkeletonCard = styled.div`
  ${skeletonCardContent}
`;
SkeletonCard.displayName = 'S.SkeletonCard';

export const clampStyles = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
